import {fetchWithAuth} from '@shared/utils/auth';
import {backendUrl} from "@shared/constants/urls/appUrls";

const TooltipSystem = {
  namespaced: true,

  state: () => ({
    coinData: {
      symbol: '',
      image: '',
      price_usd: '',
      change_1d_usd: '',
      rank: '',
      market_cap: '',
      fdv: '',
      dropstab_url: '',
    },
    isMini: false,
    isLoading: false,
    isVisible: false,
    isEmpty: false,
    error: null,
    position: {top: 0, left: 0},
    previousDataCoin: null
  }),

  mutations: {
    SET_COIN_DATA(state, data) {
      state.coinData = data;
      state.isVisible = true
    },
    SET_IS_MINI(state, isMini) {
      state.isMini = isMini;
    },
    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading;
      state.isVisible = true
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    RESET_COIN_DATA(state) {
      state.isVisible = false;
      state.position = {top: 0, left: 0};
    },
    SET_TOOLTIP_POSITION(state, position) {
      state.position = position;
    },
    SET_PREVIOUS_DATA_COIN(state, dataCoin) {
      state.isEmpty = false;
      state.previousDataCoin = dataCoin;
    },
    SET_COIN_VISIBLE(state) {
      state.isEmpty = false;
      state.isVisible = true;
    },
    SET_COIN_EMPTY(state) {
      state.isEmpty = true;
    }
  },

  actions: {

    async fetchCoinData({commit, state}, coinId) {
      if (coinId === state.previousDataCoin) {
        commit('SET_COIN_VISIBLE')
        return;
      }

      // Устанавливаем новое значение
      commit('SET_PREVIOUS_DATA_COIN', coinId);

      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      try {
        const response = await fetchWithAuth(`${backendUrl}/api/coins/${coinId}`);
        const data = await response.json();

        if (data.coin === 'Coin not found'){
          commit('SET_COIN_EMPTY')
          return
        }

        if (data.symbol) {
          commit('SET_COIN_DATA', data);
          commit('SET_IS_MINI', false);
        } else {
          commit('RESET_COIN_DATA');
          commit('SET_IS_MINI', true);
        }
      } catch (error) {
        console.error('Error fetching coin data:', error);
        commit('RESET_COIN_DATA');
        commit('SET_IS_MINI', true);
        commit('SET_ERROR', 'Failed to fetch coin data');
      } finally {
        commit('SET_LOADING', false);
      }
    },
  },

  getters: {
    changeClass(state) {
      if (state.coinData.change_1d_usd > 0) return 'title-tooltip-coin__change--green';
      if (state.coinData.change_1d_usd < 0) return 'title-tooltip-coin__change--red';
      return '';
    },
    isVisibleTooltip(state) {
      return state.isVisible
    }
  },

};

export default TooltipSystem;
